import React, { FC } from 'react';
import { LabelContainer, LabelText } from './Label.styles';

interface LabelProps {
  text: string;
  children?: React.ReactNode;
}

const Label: FC<LabelProps> = ({ children, text }) => {
  return (
    <LabelContainer className="label-container">
      <LabelText>{text}</LabelText>
      {children}
    </LabelContainer>
  );
};

export default Label;
